module.exports = __webpack_public_path__ + "img/book-logo.41447748.png";